import { Link } from "react-router-dom";
import { MdContrast, MdFormatSize, MdMap } from "react-icons/md";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useAccessibility } from "../../../context/AccessibilityContext";

const FONT_SIZE_LABELS = { small: "Pequeno", normal: "Normal", large: "Grande", xlarge: "Extra Grande" };

const features = [
  {
    key: "highContrast",
    name: "Alto Contraste",
    description: "Alterne para um tema de alta visibilidade para maior conforto visual.",
    href: "/transparencia/acessibilidade/alto-contraste",
    Icon: MdContrast,
    getStatus: (settings) => settings.highContrast ? "Ativado" : "Desativado",
    isActive: (settings) => settings.highContrast,
  },
  {
    key: "fontSize",
    name: "Redimensionamento de Texto",
    description: "Ajuste o tamanho da fonte para melhor legibilidade.",
    href: "/transparencia/acessibilidade/redimensionamento-de-texto",
    Icon: MdFormatSize,
    getStatus: (settings) => FONT_SIZE_LABELS[settings.fontSize] ?? "Normal",
    isActive: (settings) => settings.fontSize !== "normal",
  },
  {
    key: "siteMap",
    name: "Mapa do Site",
    description: "Veja todas as páginas e seções do portal de forma organizada.",
    href: "/transparencia/acessibilidade/mapa-do-site",
    Icon: MdMap,
    getStatus: () => null,
    isActive: () => false,
  },
];

const Accessibility = () => {
  const { settings } = useAccessibility();

  return (
    <div className="p-8 space-y-8">
      <p className="text-gray-600 text-base leading-relaxed max-w-2xl">
        Nosso portal oferece recursos de acessibilidade para garantir uma melhor
        experiência a todos os cidadãos. Selecione uma das opções abaixo para configurar.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map(({ name, description, href, Icon, getStatus, isActive }) => {
          const status = getStatus(settings);
          const active = isActive(settings);
          return (
            <Link
              key={href}
              to={href}
              className="flex flex-col gap-4 p-6 bg-blue-50 border border-blue-100 rounded-2xl shadow-sm hover:bg-blue-100 transition duration-200"
            >
              <div className="flex items-start justify-between">
                <Icon className="text-4xl text-blue-900" />
                {status && (
                  <span
                    className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${
                      active
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-500"
                    }`}
                  >
                    {active && <CheckCircleIcon className="h-3 w-3" />}
                    {status}
                  </span>
                )}
              </div>
              <div>
                <h2 className="text-lg font-bold text-blue-950">{name}</h2>
                <p className="text-sm text-gray-600 mt-1 leading-relaxed">{description}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Accessibility;
